module.exports = __webpack_public_path__ + "static/img/img5.64c55a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slideVerify/assets/img5.jpg
// module id = DJgC
// module chunks = 1